<template>
    <div class="dynamics">
        <ul class="breadcrumbs">
            <li class="breadcrumbs-item">Pages</li>
            <li class="breadcrumbs-item separator">/</li>
            <li class="breadcrumbs-item">Dashboard</li>
        </ul>
        <div class="dynamic-main">
            <div class="dynamic-main__top">
                <div class="dynamic-title">Dynamics</div>
                <div class="period">Time period:
                    <span class="choosePeriod" @click="openPeriods">{{ choosenPeriod.name }}</span>
                    <span class="arrow" @click="openPeriods"></span>
                    <ul class="periods" v-if="openPeriod">
                        <li class="periods-item" @click="chooseDay">Past 24 hours </li>
                        <li class="periods-item" @click="chooseWeek">Past 7 days</li>
                        <li class="periods-item" @click="chooseMonth">Past 30 days</li>
                        <li class="periods-item" @click="chooseYear">Past year</li>
                    </ul>
                </div>
            </div>

            <LineChart ref="childRef" :choosen-period="choosenPeriod.period" :data="choosenPeriod.data"
                :choosenId="choosenPeriod.id" />
        </div>
    </div>
</template>
<script>
import LineChart from '@/components/dashboard/lineChart.vue';

function lastWeek() {
    // Получаем текущий день недели
    let currentDate = new Date();

    // Определяем дату начала отображаемого периода (текущий день минус 6 дней)
    let startOfPeriod = new Date();
    startOfPeriod.setDate(currentDate.getDate() - 6);

    // Создаем массив меток оси X за последнюю неделю
    let week = [];
    for (let i = 0; i < 7; i++) {
        let date = new Date(startOfPeriod);
        date.setDate(date.getDate() + i);
        week.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'numeric' }));
    }

    return week
}

function lastMonth() {
    // Получаем текущий день недели
    let currentDate = new Date();

    // Определяем дату начала отображаемого периода (текущий день минус 6 дней)
    let startOfPeriod = new Date();
    startOfPeriod.setDate(currentDate.getDate() - 29);

    // Создаем массив меток оси X за последнюю неделю
    let month = [];
    for (let i = 0; i < 30; i++) {
        let date = new Date(startOfPeriod);
        date.setDate(date.getDate() + i);
        month.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'numeric' }));
    }

    return month
}

function lastYear() {
    let currentDate = new Date();
    let year = currentDate.getFullYear() % 100;
    let month = currentDate.getMonth() + 1;
    let months = [];

    for (let i = 0; i < 12; i++) {
        if (month === 0) {
            month = 12;
            year -= 1;
        }
        months.unshift(('0' + month).slice(-2) + '.' + ('0' + year).slice(-2));
        month -= 1;
    }
    return months;
}

function lastDay() {
    let hours = [];
    let currentDate = new Date();

    for (let i = 0; i < 24; i++) {
        let hour = currentDate.getHours() - i;
        let date = new Date(currentDate);
        date.setHours(hour);
        hours.unshift(date);
    }
    return hours;
}

export default {
    components: { LineChart },

    data: () => ({
        openPeriod: false,
        choosenPeriod: {
            id: 2,
            period: lastWeek(),
            name: 'Past 7 days',
            data: [0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5]
        }
    }),

    watch: {
        openPeriod: function (value) {
            if (value) {
                document.addEventListener('click', event => {
                    if (!document.querySelector('.choosePeriod')?.contains(event.target)) {
                        this.openPeriod = false
                    }
                });
            }
        }
    },

    methods: {
        openPeriods() {
            if (!this.openPeriod) {
                this.openPeriod = true
            } else {
                this.openPeriod = false
            }
        },

        chooseWeek() {
            this.choosenPeriod.name = 'Past 7 days'
            this.choosenPeriod.id = 2
            this.choosenPeriod.period = lastWeek()
            this.choosenPeriod.data = [0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5]
            setTimeout(() => {
                this.$refs.childRef.renderChart()
            }, "300")
        },

        chooseMonth() {
            this.choosenPeriod.name = 'Past 30 days'
            this.choosenPeriod.id = 3
            this.choosenPeriod.period = lastMonth()
            this.choosenPeriod.data = [0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.5, 0.4]
            setTimeout(() => {
                this.$refs.childRef.renderChart()
            }, "300")
        },

        chooseYear() {
            this.choosenPeriod.name = 'Past 1 Year'
            this.choosenPeriod.id = 4
            this.choosenPeriod.period = lastYear()
            this.choosenPeriod.data = [0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4]
            setTimeout(() => {
                this.$refs.childRef.renderChart()
            }, "300")
        },

        chooseDay() {
            this.choosenPeriod.name = 'Past 24 hours'
            this.choosenPeriod.id = 1
            this.choosenPeriod.period = lastDay()
            this.choosenPeriod.data = [0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4, 0.4, 0.1, 0.3, 0.2, 0.4, 0.9, 0.5, 0.4, 0.1, 0.3, 0.2, 0.4]
            setTimeout(() => {
                this.$refs.childRef.renderChart()
            }, "300")
        }

    },
}

</script>
<style scoped lang="scss">
.dynamics {
    flex: 1 1 63%;
    height: 557px;
}

.breadcrumbs {
    margin-left: 24px;
    display: flex;
}

.breadcrumbs-item {
    margin-bottom: 22px;
    color: #FFF;
    font-family: Gilroy-Medium;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    cursor: pointer;
}

.breadcrumbs-item:first-child {
    color: #A0AEC0;
}

.separator {
    margin-left: 7px;
    margin-right: 6px;
}

.dynamic-main {
    padding: 24px 7px 36px 24px;
    margin-right: 14px;
    border-radius: 20px;
    background: linear-gradient(1deg, #0B0923 -25.74%, rgba(88, 76, 114, 0.18) 99.77%);
}

.dynamic-main__top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 51px;
    margin-right: 17px;
}

.dynamic-title {
    color: #FFF;
    font-family: Gilroy-Medium;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
}

.period {
    display: flex;
    position: relative;
    align-items: center;
    color: #FFF;
    font-family: Gilroy-Medium;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
}

.choosePeriod {
    margin-left: 10px;
    font-family: Gilroy-Medium;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    background: var(--0, linear-gradient(90deg, #D574DE 1.01%, #8E54E9 82.23%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    cursor: pointer;
}

.arrow {
    width: 11px;
    height: 5px;
    margin-left: 6px;
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='7' viewBox='0 0 13 7' fill='none'%3E%3Cpath d='M12 1L6.5 6L1 1' stroke='url(%23paint0_linear_1177_9568)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_1177_9568' x1='1.11127' y1='3.87021' x2='10.0448' y2='3.87021' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
}

.periods {
    position: absolute;
    padding: 28px 20px;
    top: 31px;
    right: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='147' height='181' viewBox='0 0 147 181' fill='none'%3E%3Cg opacity='0.75'%3E%3Cg filter='url(%23filter0_dd_1177_9540)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M75.5641 10.814C74.2317 7.062 72.0714 7.062 70.7389 10.814L68.0548 18.0025C67.3547 19.8776 67.0046 20.8152 66.3968 21.5062C65.8599 22.1167 65.1823 22.587 64.4226 22.8764C63.5626 23.2041 62.5618 23.2041 60.5602 23.2041H29.4021C24.7419 23.2041 23.052 24.2626 21.3483 26.2502C19.6446 28.2378 18.3075 31.1546 17.3964 34.8712C16.4852 38.5877 16 42.2742 16 52.4402V127.764C16 137.93 16.4852 141.616 17.3964 145.333C18.3075 149.049 19.6446 151.966 21.3483 153.954C23.052 155.942 24.7419 157 29.4021 157H117.598C122.258 157 123.948 155.942 125.652 153.954C127.355 151.966 128.692 149.049 129.604 145.333C130.515 141.616 131 137.93 131 127.764V52.4402C131 42.2742 130.515 38.5877 129.604 34.8712C128.692 31.1546 127.355 28.2378 125.652 26.2502C123.948 24.2626 122.258 23.2041 117.598 23.2041H91.2952C87.292 23.2041 85.2904 23.2041 83.5705 22.5488C82.0511 21.9699 80.6958 21.0292 79.622 19.8083C78.4065 18.4263 77.7063 16.5512 76.306 12.8009L75.5641 10.814Z' fill='%230D0B17'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_dd_1177_9540' x='0' y='0' width='147' height='181' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='8'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1177_9540'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='4'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.08 0'/%3E%3CfeBlend mode='multiply' in2='effect1_dropShadow_1177_9540' result='effect2_dropShadow_1177_9540'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1177_9540' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
}

.periods-item {
    color: #FFF;
    font-family: Gilroy-Regular;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-transform: math-auto;
    cursor: pointer;
}

.periods-item:hover {
    background: var(--0, linear-gradient(90deg, #D574DE 1.01%, #8E54E9 82.23%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@media (min-width:1800px) {
    .dynamic-main {
        margin-right: 40px;
        padding: 24px 15px 36px 24px;
    }

    .dynamic-title {
        font-size: 18px;
    }

    .period {
        font-size: 18px;
    }

    .choosePeriod {
        font-size: 18px;
    }

    .arrow {
        width: 14px;
        height: 7px;
        margin-left: 18px;
    }

    .periods {
        padding: 31px 35px;
        top: 30px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='171' height='192' viewBox='0 0 171 192' fill='none'%3E%3Cg opacity='0.75'%3E%3Cg filter='url(%23filter0_dd_1177_8482)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M87.9949 11.0217C86.3844 6.99275 83.7732 6.99275 82.1627 11.0217L78.6304 19.4262C77.8859 21.1976 77.5137 22.0833 76.908 22.7338C76.3726 23.3087 75.7094 23.7494 74.972 24.0202C74.1375 24.3265 73.1768 24.3265 71.2553 24.3265H32.1991C26.5663 24.3265 24.5237 25.4632 22.4645 27.5975C20.4052 29.7319 18.7891 32.864 17.6878 36.8549C16.5865 40.8459 16 44.8045 16 55.721V136.605C16 147.522 16.5865 151.481 17.6878 155.472C18.7891 159.463 20.4052 162.595 22.4645 164.729C24.5237 166.863 26.5663 168 32.1991 168H138.801C144.434 168 146.476 166.863 148.536 164.729C150.595 162.595 152.211 159.463 153.312 155.472C154.414 151.481 155 147.522 155 136.605V55.721C155 44.8045 154.414 40.8459 153.312 36.8549C152.211 32.864 150.595 29.7319 148.536 27.5975C146.476 25.4632 144.434 24.3265 138.801 24.3265H104.218C100.375 24.3265 98.4534 24.3265 96.7845 23.7138C95.3097 23.1723 93.9832 22.2909 92.9125 21.1411C91.7011 19.84 90.9566 18.0686 89.4676 14.5258L87.9949 11.0217Z' fill='%230D0B17'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_dd_1177_8482' x='0' y='0' width='171' height='192' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='8'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1177_8482'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='4'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.08 0'/%3E%3CfeBlend mode='multiply' in2='effect1_dropShadow_1177_8482' result='effect2_dropShadow_1177_8482'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1177_8482' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
    }
}

@media (min-width: 0px) and (max-width: 1290px) {
    .dynamics {
        flex: 1 1 100%;
    }

    .breadcrumbs {
        margin-left: 31px;
    }

    .breadcrumbs-item {
        margin-bottom: 16px;
    }

    .dynamic-main {
        margin-right: 0;
        padding: 22px 10px 28px 31px;
    }

    .dynamic-title,
    .period,
    .choosePeriod {
        font-size: 14px;
    }

    .arrow {
        margin-left: 9px;
    }

    .periods {
        top: 11px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='142' height='166' viewBox='0 0 142 166' fill='none'%3E%3Cg opacity='0.75'%3E%3Cg filter='url(%23filter0_dd_1177_10149)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M72.9744 10.5307C71.6999 7.15643 69.6335 7.15643 68.359 10.5307L65.9382 16.6262C65.2146 18.4483 64.8528 19.3593 64.2459 20.0296C63.7096 20.6218 63.0392 21.0769 62.2908 21.3568C61.4438 21.6735 60.4636 21.6735 58.5031 21.6735H28.8194C24.3618 21.6735 22.7454 22.6254 21.1158 24.4129C19.4861 26.2005 18.2072 28.8236 17.3357 32.166C16.4641 35.5084 16 38.8238 16 47.9664V115.707C16 124.85 16.4641 128.165 17.3357 131.507C18.2072 134.85 19.4861 137.473 21.1158 139.261C22.7454 141.048 24.3618 142 28.8194 142H113.181C117.638 142 119.255 141.048 120.884 139.261C122.514 137.473 123.793 134.85 124.664 131.507C125.536 128.165 126 124.85 126 115.707V47.9664C126 38.8238 125.536 35.5084 124.664 32.166C123.793 28.8236 122.514 26.2005 120.884 24.4129C119.255 22.6254 117.638 21.6735 113.181 21.6735H88.2609C84.3399 21.6735 82.3794 21.6735 80.6855 21.0401C79.1888 20.4804 77.848 19.5702 76.7754 18.3857C75.5615 17.0452 74.8379 15.2231 73.3907 11.579L72.9744 10.5307Z' fill='%230D0B17'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_dd_1177_10149' x='0' y='0' width='142' height='166' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='8'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_1177_10149'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='8'/%3E%3CfeGaussianBlur stdDeviation='4'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.08 0'/%3E%3CfeBlend mode='multiply' in2='effect1_dropShadow_1177_10149' result='effect2_dropShadow_1177_10149'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1177_10149' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
    }

    .periods-item:first-child {
        margin-top: 7px;
        margin-bottom: -4px;
    }

    .periods-item:last-child {
        margin-top: -4px;
    }
}

@media (max-width: 680px) {
    .breadcrumbs {
        margin-left: 12px;
    }

    .breadcrumbs-item {
        margin-bottom: 25px;
    }

    .dynamic-main {
        padding: 17px 5px 5px 14px;
    }

    .dynamic-main__top {
        margin-bottom: 20px;
        margin-right: 12px;
    }

    .period {
        font-size: 12px;
    }

    .choosePeriod {
        margin-left: 2px;
    }

    .arrow {
        margin-left: 7px;
        margin-right: -2px;
        margin-top: 4px;
        width: 12px;
        height: 10px;
    }

    .periods {
        top: 13px;
        right: -2px;
        padding: 25px 21px;
    }
}
</style>